import { makeStyles, styled } from '@material-ui/core/styles';
import { DSTheme } from '../../../styles/themes/types';

export const TablePaginationStyled = styled('div')(({ theme }) => ({
  height: '100px',
  maxWidth: '896px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const useTablePaginationStyles = makeStyles((theme: DSTheme) => ({
  pageButton: {
    backgroundColor: 'transparent',
    border: '1px solid transparent',
    height: '24px',
    width: '24px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[600],
    cursor: 'pointer',
    fontWeight: 700,
    fontSize: '14px',

    '&.selected': {
      color: theme.palette.text.primary,
    },
  },
  arrowButton: {
    height: '48px',
    width: '94px',
    backgroundColor: theme.palette.text.secondary,
    color: theme.palette.primary.contrastText,
    cursor: 'pointer',
    fontSize: '14px',
    borderRadius: '16px',
    border: '1px solid transparent',
    textTransform: 'capitalize',

    '&:disabled': {
      backgroundColor: theme.palette.grey[600],
    },
  },
  pageList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  pageListItem: {
    marginRight: '30px',
  },
}));
